import { GiftIcon, GoalIcon, LucideIcon, ReceiptIcon, TicketIcon } from 'lucide-react'
import { RewardLedgerEntryData, RewardLedgerEntryFromType } from '../types/rewardLedgerEntries.type'

type RecordTypeConfig = {
  label: string
  icon: LucideIcon
}

export const FROM_TYPE_RECORD_MAP: Record<string, RecordTypeConfig> = {
  'Tmais::RewardProductRedemption': { label: 'Resgatou item', icon: GiftIcon },
  'Tmais::Mission': { label: 'Completou missão', icon: GoalIcon },
  'Tmais::RewardTicket': { label: 'Adquiriu bilhete', icon: TicketIcon },
  'Tmais::Consumption': { label: 'Realizou consumo', icon: ReceiptIcon },
}

const REWARD_TYPE_FALLBACK_MAP: Record<string, RecordTypeConfig> = {
  'Tmais::Raffle': { label: 'Adquiriu bilhete', icon: TicketIcon },
  'Tmais::Product': { label: 'Resgatou item', icon: GiftIcon },
}

export const getRecordTypeConfig = (entry: RewardLedgerEntryData): RecordTypeConfig => {
  if (entry.from_type && FROM_TYPE_RECORD_MAP[entry.from_type]) {
    return FROM_TYPE_RECORD_MAP[entry.from_type]
  }

  if (entry.reward_type && REWARD_TYPE_FALLBACK_MAP[entry.reward_type]) {
    return REWARD_TYPE_FALLBACK_MAP[entry.reward_type]
  }

  return { label: 'Registro', icon: GiftIcon }
}

export const FROM_TYPE_FILTER_OPTIONS: { label: string; value: RewardLedgerEntryFromType | '' }[] = [
  { label: 'Todos', value: '' },
  { label: 'Resgatou item', value: 'Tmais::RewardProductRedemption' },
  { label: 'Completou missão', value: 'Tmais::Mission' },
  { label: 'Adquiriu bilhete', value: 'Tmais::RewardTicket' },
  { label: 'Realizou consumo', value: 'Tmais::Consumption' },
]

export type CardDisplayType = 'redeemed_item' | 'completed_mission' | 'acquired_ticket' | 'consumption' | 'generic'

export const getCardDisplayType = (entry: RewardLedgerEntryData): CardDisplayType => {
  const fromType = entry.from_type as RewardLedgerEntryFromType | null

  if (fromType === 'Tmais::RewardProductRedemption') return 'redeemed_item'
  if (fromType === 'Tmais::Mission') return 'completed_mission'
  if (fromType === 'Tmais::RewardTicket') return 'acquired_ticket'
  if (fromType === 'Tmais::Consumption') return 'consumption'

  if (entry.reward_type === 'Tmais::Raffle') return 'acquired_ticket'
  if (entry.reward_type === 'Tmais::Product') return 'redeemed_item'

  return 'generic'
}
